<template>
    <div class="page-container">
      <div class="flex-between top">
        <div>
        <el-select v-model="form" placeholder="请选择课程" style="width: 100%" @change="handleChange">
  <el-option
    v-for="item in options"
    :key="item.courseId"
    :label="item.courseName"
    :value="item.courseId"  
  ></el-option>
</el-select>
        </div>
      <div class="top-icons">
        <img :src="url" alt="logo" @click="goback">
        <img :src="logo" alt="logo">

      </div>
      </div>
      
    <div class="flex-between top2">
      <h2 class="motto">笃学力行 守正求新</h2>

    </div>
      
      <div class="main-content">
        <div class="mainbox">
             <div style="width: 100%;">
        <div class="right1 flex-column-between" style="position: relative;">

            <el-table
            :data="tableData"
             height="100%"
            width="100%"
          style="font-size: 20px;border-radius: 10px;padding-top: 20px;"

            :default-sort = "{prop: 'date', order: 'descending'}"
            >
            <!-- <el-table-column type="selection" header-align="center" align="center"></el-table-column>   -->
            <el-table-column prop="userName" label="学生名称" header-align="center" align="center"></el-table-column>
            <el-table-column prop="grade" label="年级" header-align="center" align="center"></el-table-column>
            <el-table-column prop="phone" label="联系方式" header-align="center" align="center"></el-table-column>
            <el-table-column prop="responsibleTeacher" label="负责教师" header-align="center" align="center"></el-table-column>
            <el-table-column prop="counselorName" label="帮扶辅导员" header-align="center" align="center"></el-table-column>
            <el-table-column prop="targetTime" label="学习时长（min）" header-align="center" align="center">
                <template slot-scope="scope">
                  <span :style="{color: scope.row.targetTime < scope.row.targetTimeLength ? '#F56C6C' : ''}">
                    {{ scope.row.targetTime }}
                  </span>
                </template>
            </el-table-column>
            <el-table-column prop="targetTimeLength" label="目标时长（min）" header-align="center" align="center"></el-table-column>
            <el-table-column prop="currentScore" label="目前得分" header-align="center" align="center">
                      <template slot-scope="scope">
                  <span :style="{color: scope.row.currentScore < scope.row.targetScore ? '#F56C6C' : ''}">
                    {{ scope.row.currentScore }}
                  </span>
                </template>
            </el-table-column>
            <el-table-column prop="targetScore" label="目标得分" header-align="center" align="center"></el-table-column>
            <el-table-column prop="courseTime" label="开课时间" header-align="center" align="center"></el-table-column>
            <el-table-column         
              label="作业情况"
              header-align="center" align="center"
              >
              <template slot-scope="scope">   
                    <!-- <el-badge :value="scope.row.sum" class="item"  v-if="scope.row.sum>0">
                        <el-button  size="small" class="butview" @click="toggleBox(scope.row)">查看详情</el-button>
                    </el-badge> -->
                    <el-button  size="small" class="butview" @click="toggleBox(scope.row)" >查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>

     <div v-if="showBox" class="detail-box">
 
    <div class="box-header">
      <i class="el-icon-close" @click="toggleBoxss"></i>
    </div>
    <div class="box-content">


    <div class="flex-column-justify-flex-end" style="  display: flex;
      flex-direction: column;
      gap: 20px; "
      v-if=" homeworkLists.length > 0"
      >
    

      <div class="flex-between" style="height: 80px; " v-for="(item,index) in homeworkLists" :key="index">
      <div class="flex-column-between" style="margin-right: 20px; width: 320px;">
        <p class="subtitle " style="display: -webkit-box;-webkit-line-clamp: 2;  /* 限制为 2 行 */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;  /* 允许长单词换行 */">{{ item.curriculumName }}</p>
        <div class="flex-between" style="width: 100%;">
          <p class="subscore" >得分：{{ item.score }}</p>
          <p class="subtime">{{ item.createTime }}</p>
        </div>
      </div>

      <el-button type="success" style="line-height: 5px; height: 35px; width: 84px; margin: auto 0;" v-if="item.answerState == 1" >批改中</el-button>
      <el-button type="primary" style="line-height: 5px; height: 35px; width: 84px; margin: auto 0;"  v-if="item.answerState == 2" @click="watchlastDetail(item)">查看</el-button>
    </div>
    </div>
    <div v-else>
       <p style="margin:auto 0; font-size: 20px;display: flex;justify-content: center;">暂时没有发布作业</p>
    </div>
    </div>
    </div>
        </div>
        <div class="floating-box">
            <div class="cur">
                  <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageQueryDTO.curPage"
                        :page-sizes="arr"
                        :page-size="pageQueryDTO.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="count">
                  </el-pagination>
                </div>
        </div>


    </div>


 
        </div>



      </div>
  <!-- 最终试卷 -->
          <!-- 遮罩层 -->
    <div 
      v-show="showDialogs2" 
      class="overlay"
      @click="close222"
    ></div>
                <!-- 左侧对话框 -->
    <div v-show="showDialogs2" class="dialog2 left-dialog2">
      <p class="stusname">学生姓名：{{ userName }}</p>
      <div class="flex-between" style="margin-bottom: 23px;">
        <p class="stusname">卷面总分/及格线：{{ totalMark }}/{{ passMark }}</p>
        <p class="stusname">试卷得分：<span>{{ sum }}</span></p>
      </div>
            <div>
        <div class="flex-between titlebg"  
        :class="{ 'active-type': activeQuestionType === 'single' }" 
    @click="activeQuestionType = 'single'">
            <p>一、单选题</p>        
            <p ><span style="margin:  auto 0;">得分：{{ oneCount }}</span></p> 
        </div>
           <AddnewChoose 
                ref="addNewChoose"
                :count="forms.length"
                :active-box="currentFormIndex9 + 1"
                @switch-form="switchForm9"
                :show="show"
                :error-questions="errorQuestions"
            />
  
          <div class="flex-between titlebg"   :class="{ 'active-type': activeQuestionType === 'multiple' }"
  @click="activeQuestionType = 'multiple'" >
            <p>二、多选题</p>
             <p > <span style="margin:  auto 0;">得分：{{ twoCount }}</span></p>
          </div>
            <AddnewmoreChoose 
                ref="addNewChoose1"
                :count="forms1.length"
                :active-box="currentFormIndex8 + 1"                
                @switch-form="switchForm8"
                :show="show"
                :error-questionss="errorQuestionss"
            />
          <div class="flex-between titlebg"    :class="{ 'active-type': activeQuestionType === 'judge' }"
  @click="activeQuestionType = 'judge'">
            <p>三、判断题</p>
             <p ><span style="margin:  auto 0;">得分：{{ threeCount }}</span></p>
          </div>
          
            <AddnewJudgment 
                ref="addNewChoose2"
                :count="forms2.length"
                :active-box="currentFormIndex7 + 1"
                @switch-form="switchForm7"
                :show="show"
                :error-questionsss="errorQuestionsss"
            />
        <div class="flex-between titlebg" 
          :class="{ 'active-type': activeQuestionType === 'subjective' }"
  @click="activeQuestionType = 'subjective'"
        >
            <p>四、主观题</p>
            
             <p > <span style="margin:  auto 0;">得分：{{ fourCount }}</span></p>
          </div>
          
                  <AddnewSubjective
                ref="addNewChoose3"
                :count="forms3.length"
                :active-box="currentFormIndex6 + 1"
                
                @switch-form="switchForm6"
                :show="show"
            />

          
      </div>

    </div>
                  <!-- 右侧对话框 -->
<div v-show="showDialogs2" class="dialog3 right-dialog2" style="padding-right: 60px">
  <span class="close-icon" @click="close222">×</span>
    <div v-if="activeQuestionType === 'single'">
          <h2>单选题</h2>
      <!-- 所有题目容器（垂直排列） -->
  <div class="questions-container">
    <!-- 动态渲染每个题目表单 -->
    <div 
      v-for="(form, index) in forms" 
      :key="index" 
      class="current-question single-question"
      :class="{ 'active-form': currentFormIndex9 === index }"
    >
      <el-form :model="form" label-width="80px">
        <!-- 题目 -->
        <el-form-item :label="'题目' + form.sort + '：'">
          <div style="display: flex; justify-content: space-between;">
            <!-- <el-input v-model="form.question" placeholder="请输入题目" style="position: relative;"></el-input> -->
             <span>{{ form.question}}</span>
          </div>
        </el-form-item>
                      <!-- 回显题目 -->
    <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.questionPictureVo?.downloadUrl"
          :preview-src-list="form.questionPictureVo?.downloadUrl ? [form.questionPictureVo.downloadUrl] : []"
       v-if="form.questionPictureVo?.downloadUrl"
      ></el-image>

        <!-- 答案输入框 -->
        <el-row :gutter="40" >
          <el-col v-for="(answer, aIndex) in form.answers" :key="aIndex" :span="12" style="margin-bottom: 20px;">
            <el-form-item :label="answer.label+'：'">
              <!-- <span>{{ answer.value }}</span> -->
              <el-input v-model="answer.value" :placeholder="answer.label" style="position: relative;" :disabled="true"></el-input>
              <div 
               
                :class="{'checked': answer.checked}" 
                class="check-box"
                style="pointer-events: none;"
              >
                <span v-if="answer.checked">✓</span>
              </div>
  
            </el-form-item>
          </el-col>
        </el-row>
                <div class="stand" v-if="form.answerResult == 1">
          <span style="font-weight: 700;color: #0825e6;">回答正确</span>
        </div>
        <div class="stand"  v-if="form.answerResult == 2">
          <span style="font-weight: 700;color: red;">回答错误</span>
        </div>
        <div class="stand">
          <span style="font-weight: 700;"> 学生答案：</span>{{ form.questionAnswer }}
        </div>


      </el-form>
    </div>
  </div>


    </div>
   
<!-- 多选题 -->
<div v-if="activeQuestionType === 'multiple'">
    <h2>多选题</h2>
          <!-- 所有题目容器（垂直排列） -->
  <div class="questions-container">
    <!-- 动态渲染每个题目表单 -->
    <div 
      v-for="(form, index) in forms1" 
      :key="index" 
      class="current-question multiple-question"
      :class="{ 'active-form': currentFormIndex8 === index }"
    >
      <el-form :model="form" label-width="80px">
        <!-- 题目 -->
        <el-form-item :label="'题目' + form.sort + '：'">
          <div style="display: flex; justify-content: space-between;">
            <!-- <el-input v-model="form.question" placeholder="请输入题目" style="position: relative;"></el-input> -->
             <span>{{ form.question}}</span>
          </div>
        </el-form-item>
                      <!-- 回显题目 -->
    <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.questionPictureVo?.downloadUrl"
          :preview-src-list="form.questionPictureVo?.downloadUrl ? [form.questionPictureVo.downloadUrl] : []"
       v-if="form.questionPictureVo?.downloadUrl"
      ></el-image>

        <!-- 答案输入框 -->
        <el-row :gutter="40">
          <el-col v-for="(answer, aIndex) in form.answers" :key="aIndex" :span="12" style="margin-bottom: 20px;">
            <el-form-item :label="answer.label+'：'">
              <el-input v-model="answer.value" :placeholder="answer.label" style="position: relative;" :disabled="true"></el-input>
              <div 
                
                :class="{'checked': answer.checked}" 
                class="check-box"
                style="pointer-events: none;"
              >
                <span v-if="answer.checked">✓</span>
              </div>
   
            </el-form-item>
          </el-col>
        </el-row>
                <div class="stand" v-if="form.answerResult == 1">
          <span style="font-weight: 700;color: #0825e6;">回答正确</span>
        </div>
        <div class="stand"  v-if="form.answerResult == 2">
          <span style="font-weight: 700;color: red;">回答错误</span>
        </div>
          <div class="stand">
          <span style="font-weight: 700;"> 学生答案：</span>{{ form.questionAnswer }}
        </div>

    
      </el-form>
    </div>


</div>
    </div>
      <!-- 判断题 -->
<div v-if="activeQuestionType === 'judge' ">
    <h2>判断题</h2>
            <!-- 所有题目容器（垂直排列） -->
  <div class="questions-container">
    <!-- 动态渲染每个题目表单 -->
    <div 
      v-for="(form, index) in forms2" 
      :key="index" 
      class="current-question judge-question"
      :class="{ 'active-form': currentFormIndex7 === index }"
    >
      <el-form :model="form" label-width="80px">
        <!-- 题目 -->
        <el-form-item :label="'题目' + form.sort + '：'">
          <div style="display: flex; justify-content: space-between;">
            <!-- <el-input v-model="form.question" placeholder="请输入题目" style="position: relative;"></el-input> -->
            <span>{{ form.question}}</span>
          </div>
        </el-form-item>
                      <!-- 回显题目 -->
    <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.questionPictureVo?.downloadUrl"
          :preview-src-list="form.questionPictureVo?.downloadUrl ? [form.questionPictureVo.downloadUrl] : []"
       v-if="form.questionPictureVo?.downloadUrl"
      ></el-image>

        <!-- 答案输入框 -->
        <el-row :gutter="40">
          <el-col v-for="(answer, aIndex) in form.answers" :key="aIndex" :span="12">
            <el-form-item :label="answer.label+'：'">
              <el-input v-model="answer.value" :placeholder="answer.label"  :disabled="true" style="position: relative;" ></el-input>
              <div 
                
                :class="{'checked': answer.checked}" 
                class="check-box"
                style="pointer-events: none;"
              >
                <span v-if="answer.checked">✓</span>
              </div>
    
            </el-form-item>
          </el-col>
        </el-row>
                <div class="stand" v-if="form.answerResult == 1">
          <span style="font-weight: 700;color: #0825e6;">回答正确</span>
        </div>
        <div class="stand"  v-if="form.answerResult == 2">
          <span style="font-weight: 700;color: red;">回答错误</span>
        </div>
        <div class="stand">
          <span style="font-weight: 700;"> 学生答案：</span>{{ form.questionAnswer }}
        </div>

      </el-form>
    </div>
  </div>

</div>
    <!-- 主观题 -->
<div v-if="activeQuestionType === 'subjective' ">
  <h2>主观题</h2>

  <!-- 所有题目容器（垂直排列） -->
  <div class="questions-container">
    <!-- 动态渲染每个题目表单 -->
    <div 
      v-for="(form, index) in forms3" 
      :key="index" 
      class="current-question subjective-question"
      :class="{ 'active-form': currentFormIndex6 === index }"
    >
      <el-form :model="form" label-width="80px">
        <!-- 题目 -->
         <span >题目{{form.sort}}：{{ form.question }}</span>
              <!-- 回显题目 -->
    <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.questionPictureVo?.downloadUrl"
          :preview-src-list="form.questionPictureVo?.downloadUrl ? [form.questionPictureVo.downloadUrl] : []"
       v-if="form.questionPictureVo?.downloadUrl"
      ></el-image>
          <div class="stand">
         <span style="font-weight: 700;"> 学生答案：</span>{{ form.questionAnswer }}
                                                       <!-- 回显答案图片 -->
            <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.answerImageUrl"
          :preview-src-list="form.answerImageUrl ? [form.answerImageUrl] : []"
       v-if="form.answerImageUrl"
      ></el-image>
        </div>
        <div class="stand" style="margin-bottom: 50px;">
         <span style="font-weight: 700;color: brown;"> 批卷回复：</span>
         <span>{{ form.answer }}</span>
         <!-- <textarea v-model="form.answer" placeholder="请输入内容..." style="position: relative;width: 100%;height: 300px;margin-top: 10px; padding: 10px 20px 10px 10px;"></textarea> -->
        </div>

        <div class="flex-between">
          <p style="font-weight: 700;font-size: 25px;">总分：{{ form.score }}</p>
          <div>
            <span  style="font-weight: 700;font-size: 25px;color: blue;">本题得分：</span>
            <span style="font-weight: 700;font-size: 25px;color: blue;">{{ form.count  }}</span>
             <!-- <el-input-number v-model="form.initialValue" controls-position="right" @change="handleChange" :min="0" :max="form.score"></el-input-number> -->
          </div>
        </div>
        
      </el-form>
    </div>
  </div>
  



  </div>
  </div>

    </div>
  </template>
  
  <script>
  import Password from '@/components/Password/Password.vue'
  import Information from '@/components/Information/Information.vue'
  import choose from '@/views/Teacher/compontents/choose.vue'
  import AddnewChoose from '@/views/Teacher/compontents/AddnewChoose.vue'
import AddnewmoreChoose from '@/views/Teacher/compontents/AddnewmoreChoose.vue'
import AddnewJudgment from '@/views/Teacher/compontents/AddnewJudgment.vue'
import AddnewSubjective from '@/views/Teacher/compontents/AddnewSubjective.vue'
  export default {
    components: {
      Password,
      Information,
      choose,
           AddnewChoose,
     AddnewmoreChoose,
     AddnewJudgment,
     AddnewSubjective
    },
    data() {
      return {
        showBox:false,
        showDialogs2:false,
        sum:'',
        courseMsgId:'',
        courseId:'',
        studentNumber:'',
        tableform:{},
        classData:[],
        homeworkLists:[],
        teacherName:JSON.parse(localStorage.getItem('user')).userName,
        url: require('@/assets/pic/back.png'),
        logo: require('@/assets/pic/logo.png'),
        av: require('@/assets/pic/avatar.png'),
        stuname: require('@/assets/pic/stuname.png'),
        jb: require('@/assets/pic/jb.png'),
        righticon: require('@/assets/pic/righticon.png'),
        teamicon:require('@/assets/pic/teamicon.png'),
        but: require('@/assets/pic/application.png'),
        inputStudent: '',
        inputName: '',
         inform:{},
        options: [],

            activeQuestionType: 'single', // 默认选中单选题
                form: {
      courseId: null, // 当前选中的课程ID
      courseName: '', // 当前选中的课程名称
      studentNumber: '' // 当前选中的学号
    },
    counselorNumber:'',
    selectedCourse: null, // 当前选中的整个课程对象
            forms: [],          // 存储所有题目的数组
            forms1:[],
            forms2:[],
            forms3:[],
            oneCount:'',
            twoCount:'',
            threeCount:'',
            fourCount:'',
            totalMark:'',
            show:1,
            passMark:'',
            singlescore:'',
       multiplescore:'',
       judgmentscore:'',
       subjectivescore:'', 
            currentFormIndex9: 0 ,// 当前编辑的题目索引
            currentFormIndex8: 0 ,// 当前编辑的题目索引
            currentFormIndex7: 0 ,// 当前编辑的题目索引
            currentFormIndex6: 0 ,// 当前编辑的题目索引
        tableData:[
        ],
        loading:false,
        loading2:false,
        vo:[],
        userName:'',
        courseName:'',
        dialogVisible: false,
        dialogVisible1: false,
        dialogVisible2:false,
        showDialogs: false,
        showDialogs1: false,
        value1: '0',
        value: '0',
                    pageQueryDTO: {
            curPage: 1,
            pageSize: 12,
          },  
            arr: [5, 12],
            count: 0,
           courseId:'',
        leftLessons:[

        ]
      }
    },
          computed: {
                        totalScore() {
    return this.oneCount + this.twoCount + this.threeCount + this.fourCount;
  },
        // 单选
  errorQuestions() {
  // 获取 forms 和 forms1 中的错误题目索引
  const errorFromForms = this.forms
    .map((form, index) => form.answerResult === 2 ? index + 1 : null)
    .filter(item => item !== null);
  

  return errorFromForms
      
  },
  // 多选
    errorQuestionss() {
  // 获取 forms 和 forms1 中的错误题目索引
  const errorFromForms = this.forms1
    .map((form, index) => form.answerResult === 2 ? index + 1 : null)
    .filter(item => item !== null);
  

  return errorFromForms
      
      
  },
  // 判断
      errorQuestionsss() {

  const errorFromForms = this.forms2
    .map((form, index) => form.answerResult === 2 ? index + 1 : null)
    .filter(item => item !== null);

  // 合并两个数组并返回
  return errorFromForms
      
  },

},
    mounted(){
      this.check()
    },

    methods: {
            //查看最终试卷
     async watchlastDetail(selection){
      this.showDialogs2 = true
        console.log('selectionselection',selection,this.studentNumber);
        const courseMsgId = selection.courseMsgId || ''
       const params = {
        courseMsgId:courseMsgId,
        studentNumber:this.studentNumber 
       }
       console.log(params,'parwqewertet')
        try {
        const headers = { 'satoken': localStorage.getItem('token') };
        const res = await this.$http.get(
          `${this.$config.API_BASE_URL}/hz-university-pc/student/courseMsgTvAnswer`,
          {params,headers }
        );
        if (res.data.code === 200) {
          const data = res.data.data;
          this.totalMark = data.totalMark || '0';
          this.passMark = data.passMark || '0';
          this.sum = data.sum || '0';
          this.oneCount = data.oneCount || '0';
          this.twoCount = data.twoCount || '0';
          this.threeCount = data.threeCount || '0';
          this.fourCount = data.fourCount || '0';
          this.forms = data.one.map(item => {
      // 确保 options 是数组，并提取冒号后的内容
      const options = (item.options || []).map(opt => {
        // 分割字符串，取冒号后的部分
        const parts = opt.split(':');
        // 如果没找到冒号，返回原字符串；否则返回冒号后的部分
        return parts.length > 1 ? parts[1].trim() : opt;
      });
      
      // 解析正确答案（假设 correctAnswer 是像 "A" 或 "A,B" 这样的字符串）
      const correctAnswers = item.correctAnswer ? 
        item.correctAnswer.split(',').map(s => s.trim()) : 
        [];
      
      const answers = options.map((option, index) => {
        const label = String.fromCharCode(65 + index); // A, B, C...
        return {
          label,
          value: option,
          checked: correctAnswers.includes(label) // 根据正确答案设置初始状态
        };
      });
          
          return {
            question: item.questionContent,
            answers: answers,
            // 保留原始数据中的其他字段
            ...item
          };
        }) || [];
                this.forms1 = data.two.map(item => {
      // 确保 options 是数组，并提取冒号后的内容
      const options = (item.options || []).map(opt => {
        // 分割字符串，取冒号后的部分
        const parts = opt.split(':');
        // 如果没找到冒号，返回原字符串；否则返回冒号后的部分
        return parts.length > 1 ? parts[1].trim() : opt;
      });
      
      // 解析正确答案（假设 correctAnswer 是像 "A" 或 "A,B" 这样的字符串）
      const correctAnswers = item.correctAnswer ? 
        item.correctAnswer.split(',').map(s => s.trim()) : 
        [];
      
      const answers = options.map((option, index) => {
        const label = String.fromCharCode(65 + index); // A, B, C...
        return {
          label,
          value: option,
          checked: correctAnswers.includes(label) // 根据正确答案设置初始状态
        };
      });
          
          return {
            question: item.questionContent,
            answers: answers,
            // 保留原始数据中的其他字段
            ...item
          };
        }) || [];
          this.forms2 = data.three.map(item => {
           // 确保 options 是数组，并提取冒号后的内容
      const options = (item.options || []).map(opt => {
        // 分割字符串，取冒号后的部分
        const parts = opt.split(':');
        // 如果没找到冒号，返回原字符串；否则返回冒号后的部分
        return parts.length > 1 ? parts[1].trim() : opt;
      });
      
      // 解析正确答案（假设 correctAnswer 是像 "A" 或 "A,B" 这样的字符串）
      const correctAnswers = item.correctAnswer ? 
        item.correctAnswer.split(',').map(s => s.trim()) : 
        [];
      
      const answers = options.map((option, index) => {
        const label = String.fromCharCode(65 + index); // A, B, C...
        return {
          label,
          value: option,
          checked: correctAnswers.includes(label) // 根据正确答案设置初始状态
        };
      });
          return {
            question: item.questionContent,
            answers: answers,
            // 保留原始数据中的其他字段
            ...item
          };
        }) || [];
          this.forms3 = data.four.map(item => {

          
          return {
            question: item.questionContent,
            
    questionId: item.questionId,  // 假设 questionId 存在
    answers: item.answers || [],    // 确保 answers 数组存在，避免错误
    answerImageUrl: item.questionAnswerFileVO.downloadUrl || null,
            ...item
          };
        }) || [];
          console.log(data,'datadata')
          console.log(this.forms,'this.forms')
          this.singlescore = this.forms[0].score
          this.multiplescore = this.forms1[0].score
          this.judgmentscore = this.forms2[0].score
          this.subjectivescore = this.forms3[0].score
          console.log(this.forms3,'this.forms3')
            this.$message({
                type: 'success',
                message: res.data.msg
              });
        }
      } catch (error) {
        console.error("加载数据失败", error);
      }


      },
                toggleBoxss(){
            this.showBox = false
          },
            //切换显示
            toggleBox(selection){
              const studentNumber = selection.studentNumber ||''

              console.log(selection,'ssss')
            this.showBox = !this.showBox; // 切换弹出框的显示状态
            console.log(studentNumber,this.courseId,this.showBox,'111')
            if(this.showBox == true){
               this.gowatchDetail(selection)
            }else{
              return
            }
           
          },
                close222(){
                this.showDialogs2 = false
            this.currentFormIndex9= 0 ,
            this.currentFormIndex8= 0 ,
            this.currentFormIndex7= 0 ,
            this.currentFormIndex6= 0 ,
                        this.currentFormIndex= 0 ,
            this.currentFormIndex1= 0 ,
            this.currentFormIndex2= 0 ,
            this.currentFormIndex3= 0 ,
        this.forms = []
        this.forms1 = []
        this.forms2 = []
        this.forms3 = []
        // this.userName = ''
        // this.targetScore = ''
        this.totalMark = ''
        this.passMark =''
        this.singlescore  =''
        this.multiplescore  =''
        this.judgmentscore = ''
        this.subjectivescore = ''
         this.oneCount = ''
         this.twoCount = ''
        this.threeCount = ''
        this.fourCount = ''

      },
                    //查看详情作业
         async gowatchDetail(selection){
            this.studentNumber = selection.studentNumber || '';
                          this.userName = selection.userName || ''
              this.targetScore = selection.targetScore||''
                  try {
                    const headers = { 'satoken': localStorage.getItem('token') };
                    const params = {
                      courseId: this.courseId || '', 
                      studentNumber: this.studentNumber || ''
                    };
                    console.log(params,'paramsparams')
                    const res = await this.$http.get(
                      `${this.$config.API_BASE_URL}/hz-university-pc/get_student_info`,{
                        params,
                         headers }
                    );
                    if (res.data.code === 200) {
                      this.homeworkLists = res.data.data;
                      console.log(this.homeworkLists,'this.homeworkLists')

                      
                    }
                  } catch (error) {
                    console.error("加载数据失败", error);
                  }
          },
         async fetchData(val){
              const params = {
                 pageQueryDTO: this.pageQueryDTO, // 将分页参数放在 pageQueryDTO 对象中
                 type:0,
                 courseId:val.courseId,
                studentNumber:val.counselorNumber
          };
          this.courseId = val.courseId || ''
          this.counselorNumber = val.counselorNumber || ''
            try {
                  const headers = { 'satoken': localStorage.getItem('token') };
                  const res = await this.$http.post(
                    `${this.$config.API_BASE_URL}/hz-university-pc/get_admin_student_list`, params,{ headers}
                  );               
                  if (res.data.code === 200) {
                            const logList = res.data.data;
                            this.tableData = logList;
                            this.count = res.data.totalRows;
                            console.log(this.count, 'this.count');
                            console.log(this.tableData, 'this.tableData');
                  }
                } catch (error) {
                  console.error("加载专业数据失败", error);
                }
    },
          goback() {
      this.$router.go(-1);
    },
                      // 切换题目
          switchForm9(index) {
            this.currentFormIndex9 = index - 1;
            this.activeQuestionType = 'single'
            this.$nextTick(() => {
              // 更精确的选择器
            
              const questionEl = document.querySelector(
                `.single-question:nth-child(${index})`
              );
              
              if (questionEl) {
                questionEl.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'center' 
                });
                
                // 添加临时class用于高亮
                const highlightClass = 'highlight-' + Date.now();
                questionEl.classList.add(highlightClass);
                
                setTimeout(() => {
                  questionEl.classList.remove(highlightClass);
                }, 1000);
              }
            });
          },
          // 切换题目
          switchForm8(index) {
            this.currentFormIndex8 = index - 1;
            this.activeQuestionType = 'multiple'
            this.$nextTick(() => {
              // 更精确的选择器
              const questionEl = document.querySelector(
                `.multiple-question:nth-child(${index})`
              );
              
              if (questionEl) {
                questionEl.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'center' 
                });
                
                // 添加临时class用于高亮
                const highlightClass = 'highlight-' + Date.now();
                questionEl.classList.add(highlightClass);
                
                setTimeout(() => {
                  questionEl.classList.remove(highlightClass);
                }, 1000);
              }
            });
          },
          // 切换题目
          switchForm7(index) {
            this.currentFormIndex7 = index - 1;
            this.activeQuestionType = 'judge'
            this.$nextTick(() => {
              // 更精确的选择器
              const questionEl = document.querySelector(
                `.judge-question:nth-child(${index})`
              );
              
              if (questionEl) {
                questionEl.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'center' 
                });
                
                // 添加临时class用于高亮
                const highlightClass = 'highlight-' + Date.now();
                questionEl.classList.add(highlightClass);
                
                setTimeout(() => {
                  questionEl.classList.remove(highlightClass);
                }, 1000);
              }
            });
          },
          // 切换题目
          switchForm6(index) {
            this.currentFormIndex6 = index - 1;
            this.activeQuestionType = 'subjective'
            this.$nextTick(() => {
              // 更精确的选择器
              const questionEl = document.querySelector(
                `.subjective-question:nth-child(${index})`
              );
              
              if (questionEl) {
                questionEl.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'center' 
                });
                
                // 添加临时class用于高亮
                const highlightClass = 'highlight-' + Date.now();
                questionEl.classList.add(highlightClass);
                
                setTimeout(() => {
                  questionEl.classList.remove(highlightClass);
                }, 1000);
              }
            });
          },
      handleChange(courseId) {
    const selectedCourse = this.options.find(item => item.courseId === courseId);
    console.log('选中课程:', selectedCourse);
    this.fetchData(selectedCourse)
    this.toggleBoxss()
    // 其他处理逻辑
  },
async check() {
  const params = { type: 0 };
  try {
    const headers = { 'satoken': localStorage.getItem('token') };
    const res = await this.$http.get(
      `${this.$config.API_BASE_URL}/hz-university-pc/get_help_list`, 
      {params, headers}
    );
    
    if (res.data.code === 200) {
      // 过滤无效数据
      this.options = (res.data.data || []).filter(item => 
        item.courseName && item.courseName.trim() !== ""
      );
      
      // 默认选中第一个并打印
      if (this.options.length > 0) {
        this.form = this.options[0].courseId;
        console.log('默认选中的课程:', this.options[0]);
        const val = this.options[0]
        this.fetchData(val)
      } else {
        console.warn('课程列表为空，没有可选课程');
      }
      
      console.log('所有课程选项:', this.options);
    }
  } catch (error) {
    console.error("加载数据失败", error);
  }
},
                            //每页条数改变时触发
          handleSizeChange(val){
            // console.log(`每页 ${val} 条`);
            this.pageQueryDTO.pageSize = val;
            console.log( this.pageQueryDTO.pageSize,' this.pageQueryDTO.pageSize')
            const data = {
                courseId:this.courseId,
                counselorNumber:this.counselorNumber
            }
            this.fetchData(data)
          },
          // 当前页改变时触发
          handleCurrentChange(val){
            this.pageQueryDTO.curPage = val;
            console.log( this.pageQueryDTO.curPage,' this.pageQueryDTO.curPage')
                        const data = {
                courseId:this.courseId,
                counselorNumber:this.counselorNumber
            }
            this.fetchData(data)
          },

               // 监听选中的行变化
  handleSelectionChange(selection) {
      console.log('选中的行数据:', selection);
    },

  
    }
  }
  </script>
  
  <style scoped>
  .password{
      width: 150px;
      height: 35px;
      opacity: 1;
      border-radius: 15px;
      border: 1px solid rgba(39, 154, 255, 1);
      margin: auto;

      font-size: 20px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 28.96px;
      color: rgba(130, 127, 127, 1);
      text-align: center;
}
  .helllp{

font-size: 14px;
font-weight: 500;
letter-spacing: 0px;
line-height: 20.27px;
color: rgba(102, 102, 102, 0.8);


}
.les {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

/* 课程项 */
.course-item {
  gap: 0.625rem;
  margin-bottom: 3%;
      flex: 1;
  min-width: 12.5rem; /* 200px */
  display: flex;
  align-items: center;
  gap: 1rem; 
  padding: 0.4rem;
    border-radius: 0.5rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-bottom: 1rem; /* 添加一些间距 */
  background: #fff; /* 添加背景色 */
}
.course-item:hover {
  transform: translateY(-0.25rem);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.15);
  cursor: pointer;
}
.course-info {
  width: 80%;
  margin-left: 1%;
  cursor: pointer; 
}
 .titlebg {
  padding: 12px 15px;
  margin-bottom: 10px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s ease;
  cursor: pointer;
}
    .titlebg{
width: 450px;
height: 45px;
opacity: 0.5;
background: rgba(237, 243, 246, 1);
padding: 9px;
margin-bottom: 20px;
}
.titlebg:hover {
  border-color: #c0c4cc;
}
  .overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.dialog {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 495px;
  height: 80vh;
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 101;
    /* 新增滚动相关样式 */
  max-height: 80vh; /* 设置最大高度为视口的80% */
  overflow-y: auto; /* 垂直方向超出时显示滚动条 */
  display: flex;
  flex-direction: column; /* 确保内容垂直排列 */
}
.dialog1 {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 1026px;
    height: 80vh;
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 101;
      /* 新增滚动相关样式 */
  max-height: 80vh; /* 设置最大高度为视口的80% */
  overflow-y: auto; /* 垂直方向超出时显示滚动条 */
  display: flex;
  flex-direction: column; /* 确保内容垂直排列 */
}

.left-dialog {
  left: calc(50% - (495px + 1026px + 20px)/2);
}

.right-dialog {
  left: calc(50% - (495px + 1026px + 20px)/2 + 495px + 20px);
}
.close-icon {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;
}

.close-icon:hover {
  color: #333;
}
  .rednum{
      width: 39px;
      height: 25px;
      opacity: 1;
      border-radius: 5px;
      background: rgba(229, 16, 19, 1);

      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0px;
      line-height: 23.17px;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      margin-top: 1%;



  }
  .rightbottom{
    width: 100%;
    position: relative; /* 父容器设为相对定位 */
    height: 63vh;
    background: #fff;
    padding: clamp(10px, 1.0vw, 20px);
    border-radius: 10px;
  

  }
  .rightall {
    flex:0.8;
    display: flex;
    flex-direction: column;
    gap: clamp(8px, 1vw, 15px);
    min-height: 0;
  }
    .right-section {
    flex: 0.7;
    display: flex;
    flex-direction: column;
    gap: clamp(8px, 1vw, 15px);
    min-height: 0;
  }
  .buttext{
    position: absolute; /* 绝对定位 */
    left: 5%;        /* 距离左侧50px */
    top: 70%;    
    width: 30%;
    height: 20%;
    opacity: 1;

}
  .righttop{
    width: 100%;
    position: relative; /* 父容器设为相对定位 */
    height: 13vh;
    background-image: url('../../assets/pic/createbg.png');
    background-size:contain;
    border-radius: 10px;
    padding: 15px;
  }
  /* 基础重置与全局设置 */
  :root {
    font-size: 16px; /* 基准字体大小 */
  }
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  /* 响应式字体设置 */
  html {
    font-size: calc(14px + 0.3vw); /* 根据视口宽度动态调整 */
  }
  .line{
    width: 100%;
    height: 0px;
    opacity: 1;
    border: 1px solid rgba(224, 225, 242, 1);
  }
  /* 使用深度选择器穿透scoped样式 */
::v-deep .custom-dialog {
  border-radius: 30px;
  background: #fff;
  border: 2px solid #fff;
  overflow: hidden;
}
::v-deep .custom-dialog .el-dialog__header,
::v-deep .custom-dialog .el-dialog__body {
  background: transparent;
}
  /* 页面容器 */
  .page-container {
    background-image: url('../../assets/pic/background.png');
    background-size: cover;
    background-position: center;
    min-height: 100vh;
    padding: 0 clamp(10px, 2%, 20px); /* 响应式padding */
    display: flex;
    flex-direction: column;
  }
  
  /* 顶部栏优化 */
  .top {
    width: 100%;
    padding-top: clamp(10px, 2%, 20px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap; /* 小屏幕换行 */
    gap: 10px;
  }
  
  .top-icons img {
    width: clamp(30px, 3.5vw, 55px);
    height: clamp(30px, 3.5vw, 55px);
    margin-left: clamp(5px, 1vw, 15px);
  }
  
  .college-select {
    width: clamp(180px, 12vw, 220px);
  }
  
 /* 搜索区域 */
.top2 {
  width: 100%;
  /* padding: 1.25rem 6.25rem 0; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.motto {
  font-size: 1.5rem;
  font-weight: 700;
  color: #5ea5ff;
}

.search-container {
  display: flex;
  gap: 0.625rem;
}

.search-input {
  width: 18.75rem;
}

.search-btn {
  width: 5rem;
}

  /* 主要内容区域全面优化 */
  .main-content {
    width: 100%;
    padding: clamp(10px, 4%, 30px) 0 clamp(10px, 2%, 20px);
    flex: 1;
    min-height: 0;
  }
  
  .mainbox {
    width: 100%;
    height: 100%;
    display: flex;
    gap: clamp(8px, 1vw, 15px);
    min-height: 0;
  }
  
  .left-section {
    flex: 0.7;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: clamp(8px, 1vw, 15px);
    min-height: 0;
  }
  
  .middle-section {
    flex: 3.1;
    min-height: 0;
    height: 64vh;
  }
  

  
  /* 卡片通用样式 */
  .box1left {
    width: 100%;
    height: 16vh;
    border-radius: 10px;
    background: #fff;
    padding: clamp(8px, 1.0vw, 15px);

    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  .box1right1 {
    width: 100%;
    height: 56vh;
    padding: clamp(5px, 0.5vw, 5px);
    display: flex;
    flex-direction: column;

  }
  .box1left3 {
    width: 100%;
    height: 25vh;
    border-radius: 10px;
    background: #fff;
    padding: clamp(8px, 1vw, 15px);
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  /* 通知区域 */
  .notice-content {
    flex: 1;
    overflow-y: auto;
    padding-right: 5px;
  }
  
  .notice-item, .notice-item1 {
    display: flex;
    align-items: center;
    margin-top: clamp(5px, 1vh, 15px);
  }
  
  .notice-text {
    margin-left: clamp(5px, 1vw, 15px);
  }
  
  /* 文字样式全面优化 */
  .text {
    font-size: clamp(1rem, 1.3vw, 1.5rem);
    font-weight: 500;
    color: #333;
    margin-bottom: clamp(5px, 1vh, 15px);
  }
  
  .tname {
    font-size: clamp(1.2rem, 1.8vw, 1.8rem);
    font-weight: 700;
    text-align: center;
    /* margin: clamp(5px, 2vh, 20px) 0; */
  }
  
  .les, .textleft {
    font-size: clamp(0.9rem, 1.1vw, 1.2rem);
    font-weight: 500;
    color: #333;
  }
  
  .textleftdown {
    font-size: clamp(0.7rem, 0.9vw, 0.9rem);
    color: rgba(102, 102, 102, 0.8);
  }
  
  .notice-time {
    font-size: clamp(0.6rem, 0.8vw, 0.8rem);
    color: #999;
  }
  
/* 修复后的关键样式 */
.box1left1 {
  height: 59vh; /* 根据实际需要调整 */
  display: flex;
  flex-direction: column;
  padding: 15px;
  border-radius: 10px;
  background: #fff;
  /* gap: clamp(8px, 1vw, 15px); */
}

.over {
  flex: 1;
  min-height: 0; /* 关键：允许内容收缩 */
  overflow-y: auto;
  margin-top: 5%;
  padding-right: 5px;
}
.over1 {
  flex: 1;
  min-height: 0; /* 关键：允许内容收缩 */
  overflow-y: auto;
  margin-top: 5%;
  padding-right: 5px;
}

/* 可选：添加滚动条样式 */
.over::-webkit-scrollbar {
  width: 6px;
}
.over::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
  .lessontext {
    font-size: clamp(0.7rem, 0.9vw, 0.9rem);
    padding: clamp(3px, 0.5vh, 8px) clamp(8px, 1vw, 15px);
    min-width: max-content;

border-radius: 2px;
background: rgba(245, 245, 245, 1);

border: 1px solid rgba(217, 217, 217, 1);
font-size: 14px;
font-weight: 500;
letter-spacing: 0px;
line-height: 20.27px;
color: rgba(102, 102, 102, 1);



  }
  
  /* 滚动条美化 */
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
  
  /* 响应式断点优化 */
  @media (max-width: 992px) {
    .mainbox {
      flex-direction: column;
    }
    
    .left-section, .middle-section, .right-section {
      width: 100%;
    }
    
    .motto {
      text-align: center;
      margin-bottom: 10px;
    }
    
    .search-container {
      max-width: 100%;
    }
  }
  
  @media (max-width: 576px) {
    .top {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .top-icons {
      width: 100%;
      justify-content: flex-end;
      margin-top: 10px;
    }
    
    .search-container {
      flex-direction: column;
    }
    
    .search-btn {
      width: 100%;
    }
    

  }
  .right1{
    width: 100%;
    height: 77vh;
    opacity: 1;

}

.right{
height: 77vh;


border-radius: 10px;
background: rgba(255, 255, 255, 1);
box-shadow: 0px 6px 58px  rgba(196, 203, 214, 0.1);


}
.stu{

/** 文本1 */
font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 31.86px;
color: rgba(51, 51, 51, 1);
text-align: left;
margin: auto;
margin: 24px 0 15px 20px;

  }
    /* 调整Badge位置 */
.item >>> .el-badge__content {
  top: 8px !important;  /* 上移徽标 */
  right: 17px !important;   /* 靠右显示 */
}
.icon{
    font-size: 18px;
    margin: auto;
    margin-right: 10px;
  }
  .icon1{
    font-size: 18px;
    margin: auto;
    margin-right: 20px;
  }
  .butview{

width: 90px;
height: 30px;
opacity: 1;
border-radius: 50px;
background: rgba(250, 235, 220, 1);

font-size: 16px;
font-weight: 500;
letter-spacing: 0px;
line-height: 18px;
color: rgba(252, 153, 121, 1);



 }
 .lessons{

font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 31.86px;
color: rgba(51, 51, 51, 1);
margin: auto;
margin-right: 27px;

}
.left-dialog2 {
  left: calc(50% - (495px + 1026px + 20px)/2);
}
.dialog2 {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 495px;
  height: 80vh;
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 101;
    /* 新增滚动相关样式 */
  max-height: 80vh; /* 设置最大高度为视口的80% */
  overflow-y: auto; /* 垂直方向超出时显示滚动条 */
  display: flex;
  flex-direction: column; /* 确保内容垂直排列 */
}
.dialog3 {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 1026px;
    height: 80vh;
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 101;
      /* 新增滚动相关样式 */
  max-height: 80vh; /* 设置最大高度为视口的80% */
  overflow-y: auto; /* 垂直方向超出时显示滚动条 */
  display: flex;
  flex-direction: column; /* 确保内容垂直排列 */
}
.right-dialog2 {
  left: calc(50% - (495px + 1026px + 20px)/2 + 495px + 20px);
}
 .titlebg {
  padding: 12px 15px;
  margin-bottom: 10px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s ease;
  cursor: pointer;
}
    .titlebg{
width: 450px;
height: 45px;
opacity: 0.5;
background: rgba(237, 243, 246, 1);
padding: 9px;
margin-bottom: 20px;
}
.titlebg:hover {
  border-color: #c0c4cc;
}
.close-icon {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;
}

.close-icon:hover {
  color: #333;
}
  /* 单个题目表单 */
.current-question {
  padding: 35px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}
/* 当前激活的题目 */
.active-form {
  border: 2px solid #409eff;
}

/* 复选框样式 */
.check-box {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
  text-align: center;
  line-height: 20px;
}

.check-box.checked {
  background-color: #409eff;
  color: white;
}
.active-type {
  border: 2px solid #409eff !important;
  background-color: #f5f9ff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}
/* 复选框样式 */
.check-box {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
  text-align: center;
  line-height: 20px;
}

.check-box.checked {
  background-color: #409eff;
  color: white;
}
/* 改进后的勾勾按钮，放到选项框外面 */
.check-box {
  position: absolute;
  top: 50%;
  left: 100%; /* 使勾选框出现在输入框的右侧 */
  margin-left: 10px; /* 添加适当的间距 */
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border: 2px solid #409EFF;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 10; /* 确保勾选框在前面 */
}

.check-box.checked {
  background-color: #409EFF;
  border-color: #409EFF;
}

.check-box .check-icon {
  width: 10px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
.stand{
 
width: 100%;

margin-top: 20px;
  border: 1px solid rgba(240, 240, 240, 1);
  /* background: rgba(237, 243, 246, 1); */

}
.finish {
  width: 350px;
  height: 40px;
  opacity: 1;
  border-radius: 50px;
  border: 1px solid rgb(14, 12, 12);
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 40px;
  color: rgba(67, 67, 67, 1);
  text-align: center;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 50px;
  background: white;
  transition: all 0.3s ease; /* 添加过渡效果 */
}

/* 鼠标悬停效果 */
.finish:hover {
  background: #1890ff; /* 蓝色背景 */
  color: white; /* 白色文字 */
  border-color: #1890ff; /* 边框颜色与背景一致 */
  transform: translateY(2px); /* 轻微下移模拟按下效果 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 添加阴影增强立体感 */
}

/* 点击时的效果 */
.finish:active {
  transform: translateY(4px); /* 按下时下移更多 */
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /* 减小阴影 */
}
 .detail-box {
   position: absolute;
  top: 0;          /* 顶部对齐 right1 */
  right: 0;        /* 右侧对齐 right1 */
  bottom: 0;       /* 底部对齐 right1 */
  width: 450px;    /* 固定宽度 */
  background: rgba(255, 255, 255, 0.9);
  box-shadow: -2px 0px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  z-index: 10;
  overflow-y: auto;
    display: flex;
  flex-direction: column; /* 垂直布局 */
}
.box-header {
  padding-bottom: 30px; /* 替代原来的margin-bottom */
  /* 可以根据需要添加其他样式 */
}
.box-content {
  flex: 1;
  overflow-y: auto; /* 使得内容区域支持滚动 */
  padding-right: 5px; /* 为滚动条留出空间 */
}
.subscore{

font-size: 15px;
font-weight: 500;
color: rgba(39, 154, 255, 1);


}
.subtime{

font-size: 15px;
font-weight: 500;
color: rgba(153, 153, 153, 1);
 text-align: right; 
 line-height: 25px;

}
.subtitle{
  width: 100%;
font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 26.06px;
color: rgba(67, 67, 67, 1);

}
.floating-box{
display: flex;
justify-content: end;
position: fixed;     
right: 44px;        
bottom: 20px;        


}
.cur >>> .el-pagination {
  display: flex !important;
  align-items: center !important; /* 垂直居中 */
  gap: 10px !important; /* 元素间距 */
  margin-left: 20px !important;
}

/* 调整页码按钮样式 */
.cur >>> .el-pagination .btn-prev,
.cur >>> .el-pagination .btn-next,
.cur >>> .el-pagination .number {
  margin-top: 0 !important; /* 移除手动 margin */
  vertical-align: middle !important; /* 确保垂直对齐 */
}

/* 调整输入框样式 */
.cur >>> .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
  margin-top: 0 !important; /* 移除手动 margin */
}

/* 调整跳转文字样式 */
.cur >>> .el-pagination__jump {
  margin-left: 10px !important;
  margin-top: 0 !important;
}
  </style>